import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import ChangePasswordAfterResetForm from './ChangePasswordAfterResetForm';
import CommonPaper from '../common/CommonPaper';
import CommonContainer, { SIZE_HALF } from '../common/CommonContainer';
import { HOME_REDIRECT_URL } from '../../utils/redirect-const';
import { requestChangePassword } from '../../actions/auth-actions';
import CommonCenterContainer from '../common/CommonCenterContainer';

const ChangePasswordAfterReset = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const requestResult = useSelector(state => state.api.requestResult);
  const { resetPasswordRequestId } = useParams();

  React.useEffect(() => {
    if (requestResult && requestResult.success) {
      navigate(HOME_REDIRECT_URL);
    }
  }, [requestResult, navigate]);

  return (
    <CommonCenterContainer>
      <CommonContainer size={SIZE_HALF} component={CommonPaper}>
        <Typography paragraph variant="h5">
          Zmiana hasła
        </Typography>
        <ChangePasswordAfterResetForm
          onSubmit={data => dispatch(requestChangePassword(data))}
          initialValues={{ requestId: resetPasswordRequestId }} />
      </CommonContainer>
    </CommonCenterContainer>
  );
};

ChangePasswordAfterReset.propTypes = {
  resetPasswordRequestId: PropTypes.string,
  requestChangePassword: PropTypes.func,
};

export default ChangePasswordAfterReset;
